import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },

  Storage: {
    region: process.env.REACT_APP_COGNITO_REGION,
    bucket: process.env.REACT_APP_S3_BUCKET,
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    level: "public",
  },

  API: {
    endpoints: [
      {
        name: "get",
        endpoint: process.env.REACT_APP_API_GATEWAY,
        region: process.env.REACT_APP_COGNITO_REGION,
      },
      {
        name: "list",
        endpoint: process.env.REACT_APP_API_GATEWAY,
        region: process.env.REACT_APP_COGNITO_REGION,
      },
      {
        name: "post",
        endpoint: process.env.REACT_APP_API_GATEWAY,
        region: process.env.REACT_APP_COGNITO_REGION,
      },
      {
        name: "put",
        endpoint: process.env.REACT_APP_API_GATEWAY,
        region: process.env.REACT_APP_COGNITO_REGION,
      },
      {
        name: "delete",
        endpoint: process.env.REACT_APP_API_GATEWAY,
        region: process.env.REACT_APP_COGNITO_REGION,
      },
    ],
  },
});

ReactDOM.render(<App />, document.getElementById("root"));
